











import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
@Component({
  name: 'deleteDialog'
})
export default class extends Vue {
  @Prop() private dialog!: {
    isDeleVisible:boolean
  }
  @Prop() private userData!: {}
  @Prop() private deleData!: {}
  // 解决异步数据子组件获取不到数据
  @Watch('userData')
  getUserInfo(value: any) {
    this.userData = value
  }
  // 功能函数

  // 表单提交
  private handleSubmit() {
    this.$emit('delete')
    this.handleClose()
  }
  // ui

  // 表单取消
  private handleClose() {
    this.dialog.isDeleVisible = false
    this.$emit('handleClose')
    this.$emit('clearSelection')
  }
}
